export default class BenefitsHistoryEntry {
  tsdNo: number;
  akaName: string;
  year: number;

  health: number;
  employeeHealth: number;
  companyHealth: number;

  dental: number;
  employeeDental: number;
  companyDental: number;

  vision: number;
  employeeVision: number;
  companyVision: number;

  life: number;
  employeeLife: number;
  companyLife: number;

  disability: number;
  employeeDisability: number;
  companyDisability: number;

  vacation: number;
  employeeVacation: number;
  companyVacation: number;

  personal: number;
  employeePersonal: number;
  companyPersonal: number;

  holiday: number;
  employeeHoliday: number;
  companyHoliday: number;

  _401K: number;
  employee401K: number;
  company401K: number;

  fica: number;
  employeeFICA: number;
  companyFICA: number;

  workersComp: number;
  employeeWorkersComp: number;
  companyWorkersComp: number;

  insurance: number;
  employeeInsurance: number;
  companyInsurance: number;

  pto: number;
  employeePto: number;
  companyPto: number;

  benefits: number;
  employeeBenefits: number;
  companyBenefits: number;

  excludingPto: number;
  employeeExcludingPto: number;
  companyExcludingPto: number;

  salary: number;

  payBenefits: number;
  employeePayBenefits: number;
  companyPayBenefits: number;

  active: boolean;
}


// WEBPACK FOOTER //
// ./src/models/personnel/BenefitHistoryEntry.ts